import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Landmark as LandmarkIcon, Calendar, MapPin } from 'lucide-react';
import { Footer } from '../components/Footer';
import { ScrollToTop } from '../components/ScrollToTop';
import { landmarks } from '../data/landmarks';
export function LandmarksPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-white" data-id="element-1130">
      {/* Hero */}
      <div className="border-b border-gray-200" data-id="element-1131">
        <div className="max-w-7xl mx-auto px-8 lg:px-12 py-20 md:py-32" data-id="element-1132">
          <motion.div initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          duration: 0.6
        }} className="max-w-4xl" data-id="element-1133">
            <div className="h-px w-16 bg-amber-500 mb-8" data-id="element-1134"></div>
            <h1 className="text-7xl md:text-9xl font-light text-gray-900 mb-6 leading-[0.9] tracking-tight" data-id="element-1135">
              Historic
              <br data-id="element-1136" />
              <span className="font-serif italic" data-id="element-1137">Landmarks</span>
            </h1>
            <p className="text-2xl md:text-3xl text-gray-600 leading-relaxed font-light max-w-2xl" data-id="element-1138">
              Discover the iconic monuments and historic sites that define
              Nairobi's skyline and tell Kenya's story.
            </p>
          </motion.div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-8 lg:px-12 py-16" data-id="element-1139">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1140">
          {landmarks.map((landmark, index) => <motion.div key={landmark.id} className="border border-gray-200 p-8 hover:border-amber-500 transition-all" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} data-id="element-1141">
              {/* Type Badge */}
              <span className="px-3 py-1 border border-gray-200 text-gray-600 text-xs font-light uppercase tracking-widest inline-block mb-4" data-id="element-1142">
                {landmark.type}
              </span>

              {/* Name */}
              <h3 className="text-2xl font-light text-gray-900 mb-3" data-id="element-1143">
                {landmark.name}
              </h3>

              {/* Location & Year */}
              <div className="flex items-center gap-4 text-gray-500 mb-4 text-xs" data-id="element-1144">
                <div className="flex items-center gap-1" data-id="element-1145">
                  <MapPin className="w-3 h-3" strokeWidth={1.5} data-id="element-1146" />
                  <span className="font-light" data-id="element-1147">{landmark.neighborhood}</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-1148">
                  <Calendar className="w-3 h-3" strokeWidth={1.5} data-id="element-1149" />
                  <span className="font-light" data-id="element-1150">
                    Est. {landmark.yearEstablished}
                  </span>
                </div>
              </div>

              {/* Description */}
              <p className="text-gray-700 leading-relaxed mb-6 font-light text-sm" data-id="element-1151">
                {landmark.description}
              </p>

              {/* Significance */}
              <div className="mb-6 pb-6 border-b border-gray-200" data-id="element-1152">
                <h4 className="text-xs font-light text-gray-500 uppercase tracking-wider mb-3" data-id="element-1153">
                  Historical Significance
                </h4>
                <p className="text-xs text-gray-600 leading-relaxed font-light" data-id="element-1154">
                  {landmark.significance}
                </p>
              </div>

              {/* Visit Info */}
              <div className="space-y-2 text-xs font-light" data-id="element-1155">
                <div className="flex items-start gap-2" data-id="element-1156">
                  <span className="text-gray-900 font-normal" data-id="element-1157">Hours:</span>
                  <span className="text-gray-600" data-id="element-1158">
                    {landmark.visitInfo.hours}
                  </span>
                </div>
                <div className="flex items-start gap-2" data-id="element-1159">
                  <span className="text-gray-900 font-normal" data-id="element-1160">Entry:</span>
                  <span className="text-gray-600" data-id="element-1161">
                    {landmark.visitInfo.entryFee}
                  </span>
                </div>
                <div className="flex items-start gap-2" data-id="element-1162">
                  <span className="text-gray-900 font-normal" data-id="element-1163">Access:</span>
                  <span className="text-gray-600" data-id="element-1164">
                    {landmark.visitInfo.accessibility}
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>

      <ScrollToTop data-id="element-1165" />
      <Footer data-id="element-1166" />
    </div>;
}